import { ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DaumPostcode } from '../utils/daum-postcode';
import { CommonModule } from '@angular/common';
import { KakaoGeocoder } from '../utils/kakao-geocoder';
import { FormsModule } from '@angular/forms';
import { NpPointDraggableMapComponent } from '../kakao-map/np-point-draggable-map/np-point-draggable-map.component';
import { NpFcvErrorComponent } from '@newpla/common';
import { KakaoMapUtils } from '../utils/kakao-map-utils';

declare var kakao: any;

@Component({
  selector: 'np-search-address-modal',
  standalone: true,
  templateUrl: './np-search-address-modal.component.html',
  styleUrl: './np-search-address-modal.component.scss',
  imports: [CommonModule, FormsModule, NpPointDraggableMapComponent, NpFcvErrorComponent]
})
export class NpSearchAddressModalComponent implements OnInit {

  @Input()
  daumTheme = {
    searchBgColor: "#2D3847", //검색창 배경색
    queryTextColor: "#FFFFFF" //검색창 글자색
  }

  @Input()
  keyword!: string;

  @Input()
  _address2 = false;

  geocoder: any = new kakao.maps.services.Geocoder();

  activeModal = inject(NgbActiveModal);

  @ViewChild('daum_search_address_iframe', { static: true })
  element_layer?: ElementRef<HTMLElement>;

  ngOnInit(): void {
    this.search();
  }

  form1: any = {
    address1: '',
    address2: '',
    area: '',
    area1: '',
    area2: '',
    area3: '',
    zonecode: '',
    coords: {},
  }

  async search() {

    this.form1 = {
      address1: '',
      address2: '',
      area: '',
      area1: '',
      area2: '',
      area3: '',
      zonecode: '',
      coords: {},
    }

    let postcodeResult = await DaumPostcode.postcodeEmbed(this.element_layer?.nativeElement, { q: this.keyword });
    if (postcodeResult.length < 1) {
      return;
    }

    const address1 = postcodeResult.road_address || postcodeResult.address;
    const zonecode = postcodeResult.zonecode;

    let geoAddrResult = await KakaoGeocoder.addressSearch(address1);
    if (!geoAddrResult || geoAddrResult.length < 1) {
      alert("좌표 정보가 없는 주소지입니다. 다시 선택해 주세요.")
      this.keyword = postcodeResult.query;
      this.search();
      return;
    }

    const geoResultFst = geoAddrResult[0];

    let npAddress = KakaoMapUtils.kakao2NpAddressWithZonecode(geoResultFst, zonecode);
    if (!npAddress.coords) {
      alert("좌표 정보가 없는 주소지입니다. 다시 선택해 주세요.")
      this.keyword = postcodeResult.query;
      this.search();
      return;
    }

    // 주소정보 세팅
    this.form1.address1 = npAddress.address1;
    this.form1.zonecode = npAddress.zonecode;
    this.form1.area = npAddress.area;
    this.form1.area1 = npAddress.area1;
    this.form1.area2 = npAddress.area2;
    this.form1.area3 = npAddress.area3;
    this.form1.coords = npAddress.coords;

    // address2 까지 입력하는 것이 아니라면
    if (this._address2 === false) {
      this.activeModal.close(this.form1);
    }

  }

  // 주소-좌표 변환 객체를 생성합니다
  // searchCoords(keyword) {

  //   // 주소로 좌표를 검색합니다
  //   this.geocoder.addressSearch(keyword, (result, status) => {

  //     if (status === kakao.maps.services.Status.OK && result[0].y && result[0].x) {
  //       this.result.coordinates = result[0];
  //       let coords = new kakao.maps.LatLng(this.result.coordinates.y, this.result.coordinates.x);
  //       var marker = new kakao.maps.Marker({
  //         position: coords
  //       });
  //       this.map.markers = [marker];
  //       this.map.options = {
  //         //지도를 생성할 때 필요한 기본 옵션
  //         center: coords, //지도의 중심좌표.
  //         level: 7 //지도의 레벨(확대, 축소 정도)
  //       };
  //     } else {
  //       this.map.markers = [];
  //       this.map.options = null;
  //     }

  //     this.cdr.detectChanges();

  //     // 정상적으로 검색이 완료됐으면 
  //     // if (status === kakao.maps.services.Status.OK) {

  //     //   console.log(result);
  //     //   console.log(status);

  //     // var coords = new kakao.maps.LatLng(result[0].y, result[0].x);

  //     // // 결과값으로 받은 위치를 마커로 표시합니다
  //     // var marker = new kakao.maps.Marker({
  //     //   map: map,
  //     //   position: coords
  //     // });

  //     // // 인포윈도우로 장소에 대한 설명을 표시합니다
  //     // var infowindow = new kakao.maps.InfoWindow({
  //     //   content: '<div style="width:150px;text-align:center;padding:6px 0;">우리회사</div>'
  //     // });
  //     // infowindow.open(map, marker);

  //     // // 지도의 중심을 결과값으로 받은 위치로 이동시킵니다
  //     // map.setCenter(coords);
  //     // }
  //   });

  // }

  // searchAddrFromCoords(lng, lat) {
  // 좌표로 행정동 주소 정보를 요청합니다
  // this.geocoder.coord2RegionCode(lng, lat, (result, status) => {

  //   console.log('coord2RegionCode', status);
  //   console.log('coord2RegionCode', result);
  // });
  // }

  searchAgain() {
    this.search();
  }

  ngForm1Submit() {
    this.activeModal.close(this.form1);
  }

}
